import { observer } from 'mobx-react-lite'
import Timeline from './components/Timeline/Timeline'
import useCurriculumView from './hooks/useCurriculumView'
import s from './styles/CurriculumView.module.scss'

const CurriculumView = observer(() => {
	const {
		activeGradeMeta,
		sessionsForActiveGrade,
		completedCount,
		totalCount,
		progressPercent,
		handleResourceClick,
		handleAssignmentClick,
		handleMarkComplete,
	} = useCurriculumView()

	return (
		<div className={s.wrap}>
			<header className={s.header}>
				<div className={s.header__content}>
					<div className={s.header__info}>
						<h2 className={s.title}>{activeGradeMeta.title}</h2>
						<p className={s.desc}>{activeGradeMeta.description}</p>
					</div>

					<div className={s.progress}>
						<div className={s.progress__top}>
							<span className={s.progress__label}>
								{completedCount} of {totalCount} sessions completed
							</span>
							<span className={s.progress__percent}>{progressPercent}%</span>
						</div>

						<div className={s.progress__track}>
							<div
								className={s.progress__fill}
								style={{ width: `${progressPercent}%` }}
							/>
						</div>
					</div>
				</div>
			</header>

			<Timeline
				sessions={sessionsForActiveGrade}
				onResourceClick={handleResourceClick}
				onAssignmentClick={handleAssignmentClick}
				onMarkComplete={handleMarkComplete}
			/>
		</div>
	)
})

export default CurriculumView
